import { useContext } from "react";
import { UserPreferenceContext } from "./UserPreferenceContext";

export const usePreference = () => {
    const context = useContext(UserPreferenceContext);

    return context;
}